import { Box, useTheme } from '@mui/material'
import { NormalText } from '../../shared/styles'
import { ContainerBalance, ContainerBalanceItemStyled } from './styles'
// import { BuySellModal } from './buy-sell-modal'
import { coins } from '../mockedData'

export const ResumeBalance = ({ isErrorBalances, balances }) => {
  const { palette } = useTheme()

  if (isErrorBalances) {
    return (
      <NormalText color={palette.error.main}>Error loading balances</NormalText>
    )
  }

  return (
    <ContainerBalance>
      {/* <ModalV2
        isOpen={showModal}
        handleClose={handleCloseModal}
        title={"Buy / Sell"}
      >
        <BuySellModal />
      </ModalV2> */}
      {Object.entries(balances)
        // .filter(([coin]) => !coin.toLowerCase().includes("tron")) // Filter coins with "TRON"
        .map(([coin, balance]) => (
          <ContainerBalanceItemStyled key={coin}>
            <Box display={'flex'} flexDirection={'column'} gap={'8px'}>
              <NormalText color={palette.neutral.black} size={24} isBold>
                {parseFloat(balance?.split(' ')[0])}
              </NormalText>
              <NormalText size={14}>{coin}</NormalText>
            </Box>
            <img
              src={
                coins.find(
                  (c) =>
                    c.value === coin ||
                    coin?.toLowerCase()?.includes(c.value.toLowerCase())
                )?.icon
              }
              alt={coin}
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
              }}
            />
          </ContainerBalanceItemStyled>
        ))}
    </ContainerBalance>
  )
}
